import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import { ROLES } from "utils/rbac";
import Login from "pages/login";
import Dashboard from "pages/dashboard";
import CaseManagement from "pages/case-management";
import ClientManagement from "pages/client-management";
import DocumentManagement from "pages/document-management";
import ClientPortal from "pages/client-portal";
import PartnerPortal from "pages/partner-portal";
import PublicLanding from "pages/public-landing";
import ClientRegistration from "pages/client-registration";
import LawyerMatching from "pages/lawyer-matching";
import ContactLawyer from "pages/contact-lawyer";
import LawyerProfile from "pages/lawyer-profile";
import VideoConsultation from "pages/video-consultation";
import PitchDeck from "pages/pitch-deck";
import AdminDashboard from "pages/admin-dashboard";
import EmailVerificationPending from "pages/email-verification-pending";
import EmailVerificationConfirmation from "pages/email-verification-confirmation";
import ClientProfileSetup from "pages/client-profile-setup";
import TimeTrackingDashboard from "pages/time-tracking-dashboard";
import TimeEntryManagement from "pages/time-entry-management";
import LawyerRateManagement from "pages/lawyer-rate-management";
import InvoiceManagement from "pages/invoice-management";
import ForgotPasswordRequest from "pages/forgot-password-request";
import ResetPassword from "pages/reset-password";
import PasswordResetSuccess from "pages/password-reset-success";
import TermsAndConditions from "pages/terms-and-conditions";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLanding />} />
          <Route path="/client-registration" element={<ClientRegistration />} />
          <Route path="/lawyer-matching" element={<LawyerMatching />} />
          <Route path="/contact-lawyer" element={<ContactLawyer />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pitch-deck" element={<PitchDeck />} />
          <Route path="/email-verification-pending" element={<EmailVerificationPending />} />
          <Route path="/email-verification-confirmation" element={<EmailVerificationConfirmation />} />
          <Route path="/client-profile-setup" element={<ClientProfileSetup />} />
          <Route path="/forgot-password-request" element={<ForgotPasswordRequest />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/password-reset-success" element={<PasswordResetSuccess />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          
          {/* Protected Routes - Lawyer, Partner, Admin */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/case-management" 
            element={
              <ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}>
                <CaseManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/client-management" 
            element={
              <ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}>
                <ClientManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/document-management" 
            element={
              <ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}>
                <DocumentManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/lawyer-profile" 
            element={<ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}><LawyerProfile /></ProtectedRoute>} 
          />
          <Route 
            path="/time-tracking-dashboard" 
            element={<ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}><TimeTrackingDashboard /></ProtectedRoute>} 
          />
          <Route 
            path="/time-entry-management" 
            element={<ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}><TimeEntryManagement /></ProtectedRoute>} 
          />
          <Route 
            path="/lawyer-rate-management" 
            element={<ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}><LawyerRateManagement /></ProtectedRoute>} 
          />
          <Route 
            path="/invoice-management" 
            element={<ProtectedRoute allowedRoles={[ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}><InvoiceManagement /></ProtectedRoute>} 
          />
          
          {/* Protected Routes - All Authenticated Users */}
          <Route 
            path="/video-consultation" 
            element={
              <ProtectedRoute allowedRoles={[ROLES?.CLIENT, ROLES?.LAWYER, ROLES?.PARTNER, ROLES?.ADMIN]}>
                <VideoConsultation />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Routes - Client Only */}
          <Route 
            path="/client-portal" 
            element={
              <ProtectedRoute allowedRoles={[ROLES?.CLIENT]}>
                <ClientPortal />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Routes - Partner and Admin Only */}
          <Route 
            path="/partner-portal" 
            element={
              <ProtectedRoute allowedRoles={[ROLES?.PARTNER, ROLES?.ADMIN]}>
                <PartnerPortal />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Routes - Admin Only */}
          <Route 
            path="/admin-dashboard" 
            element={
              <ProtectedRoute allowedRoles={[ROLES?.ADMIN]}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Fallback */}
          <Route path="*" element={<PublicLanding />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;